export default __webpack_public_path__ + "static/media/Kosalan Enruned.eda34c49.jpg";